export const LIMITS = [7, 22]
export const DISPLAY_MULTIPLIER = 1.3
export const DEFAULT_MEETING_COLOR = '#cc0000'